<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
    dataView: {
        type: Object,
        required: false,
    },
    as: {
        required: false,
    }
});

const dataView = inject('dataView', null);

if (!dataView && !props.dataView) {
    throw new Error('No dataView found');
}

const view = computed(() => props.dataView ? props.dataView : dataView);

const buttonProps = computed(() => {
    if (props.as) {
        return undefined;
    }

    return {
        icon: 'search',
        'aria-label': 'Open query mode',
        'button-style': view.value.activeView.queryViewOpen || badgeCount.value ? 'filled-tonal' : 'standard',
        selected: view.value.activeView.queryViewOpen,
    }
});

const badgeCount = computed(() => {
    return view.value.activeView.hasQuery() ? 1 : 0;
});
</script>

<template>
    <component class="relative" :is="as ? as : 'app-icon-button'" @click="view.activeView.toggleQueryView()" v-bind="buttonProps">
        <app-badge class="absolute top-0 right-0" :count="badgeCount" />
    </component>
</template>
